import Content from "../../help/capacity-check.mdx";

export function CapacityCheckHelpPage() {
  return <Content />;
}
